module.exports = __webpack_public_path__ + "img/ladder.9fe1ec19.png";